module.exports = __webpack_public_path__ + "img/sumary_planted_equivalently.0a30bedb.svg";